import { OpenapiSingleton } from "../OpenapiSingleton";
import { isApp } from "../utils";
import { loadScript } from "./utils/loadScript";
import appState from "src/model/state";

declare global {
  interface Window {
    OneTrust: {
      OnConsentChanged: (callback: () => void) => void;
      GetConsentStatus: () => boolean;
    };
  }
}

function getCookiesConsent(data) {
  return data?.support?.cookies?.cookiesConsent?.oneTrust?.ids?.web;
}

export const oneTrustCookieScriptLoad = async (cookiesPopUpEnabledInApps:boolean) => {
  const { market } = appState.get();
  const isAppEnvironment = isApp();
  if (!isAppEnvironment || (isAppEnvironment && cookiesPopUpEnabledInApps)) {
    const data = await OpenapiSingleton.CatalogApiInstance.oneTrustIdAndLoadScript(market?.marketId?.toString() ?? "");
    const cookiesConsentId = getCookiesConsent(data);
    
    if (cookiesConsentId) {
      const cookiesArgsForScript = {
        src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
        type: "text/javascript",
        onload: () => console.log("OneTrust script loaded"),
        id: cookiesConsentId,
        dataDocumentLanguage: true
      }
      loadScript(cookiesArgsForScript)
    } else {
      console.log("Cookies Consent is not defined.");
    }
  }
}

